import styles from './styles/completeConfig.module.css';

const ConfigSuccess = ({ onNextStep }) => {
return (
<div className={`col-4 ${styles.lato_form}`}>
    <div className={`p-4 border rounded ${styles.containerloginform}`}>
        <div className={`p-4 border rounded ${styles.containerTesto}`}>
                            <h4>Configurazione completata!</h4>
        </div>
        <div className={`p-4 border rounded ${styles.containerTesto}`}>
            <p className="mb-4">
                La tua configurazione del profilo è stata completata correttamente.
                <br />
                Ora puoi effettuare nuovamente l’accesso per iniziare a utilizzare il sistema.
            </p>
        </div>
        
    <button
            onClick={() => onNextStep('login')}
            className={`btn btn-primary ${styles.btnLink}`}>   
            Accedi
    </button>
    </div>
    </div>
);
};

export default ConfigSuccess;
